import { camelToDashCase } from '../primitives/string.js';

/**
 * Converts a CSSStyleDeclaration key to a CSS property key.
 *
 * Note:
 * If the key starts with "webkit" or "moz", the function prepends a dash.
 * For example, the "webkit" prefix is used like -webkit-transition.
 *
 * @param key CSSStyleDeclaration key
 * @returns CSS property key
 */
const cssKey = (key: string): string => camelToDashCase(/^(webkit|moz)/.test(key) ? `-${key}` : key);

/**
 * Converts a Partial<CSSStyleDeclaration> to a `cssText` string.
 *
 * @param css object with CSSStyleDeclaration properties
 * @returns `cssText` string
 */
export const cssText = (css: Partial<CSSStyleDeclaration>) => Object.entries(css).map(([key, value]) => [cssKey(key), value].join(':')).join(';');

/**
 * Overwrite CSSStyleDeclaration on a DOM element's style attribute.
 *
 * @param element a DOM element
 * @param styles object with CSSStyleDeclaration properties
 */
export const setStyles = (element: HTMLElement, styles: Partial<CSSStyleDeclaration>) => {
  element.style.cssText = cssText(styles);
};


/**
* Merge CSSStyleDeclaration on a DOM element's already existing style attribute.
*
* @param element a DOM element
* @param styles object with CSSStyleDeclaration properties
*/
export const addStyles = (element: HTMLElement, styles: Partial<CSSStyleDeclaration>) => {
  element.style.cssText += cssText(styles);
}
